import React from 'react';

import ASLVideoUploadNote from './ASLVideoUploadNote';
import { ASLVideoUploadMain } from 'features/assetManagement';

function ASLVideoUploadPage() {
  return (
    <>
      <ASLVideoUploadNote />
      <ASLVideoUploadMain />
    </>
  );
}

export default ASLVideoUploadPage;
